import { Paper } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Details } from "src/shared/components/Details";
import { DetailsRow } from "src/shared/components/Details/types";
import { TCaseData } from "../data-access/types";
import { format, parseISO } from "date-fns";

export default function CaseDetails({ caseData }: { caseData: TCaseData }) {
  const { t } = useTranslation();

  const rows = [
    {
      name: t("Αριθμός Υπόθεσης"),
      value: caseData?.case_id,
    },
    {
      name: t("Ημερομηνία Δημιουργίας Υπόθεσης"),
      value: format(parseISO(caseData.date_created), "dd/MM/yyyy HH:mm"),
    },
    {
      name: t("Ημερομηνία Ολοκλήρωσης Υπόθεσης"),
      value: caseData.completed_date
        ? format(parseISO(caseData.completed_date), "dd/MM/yyyy HH:mm")
        : null,
    },
    {
      name: t("Κατάσταση Υπόθεσης"),
      value: caseData.status === 0 ? t("Εκρεμμεί") : t("Ολοκληρώθηκε"),
    },
    {
      name: t("Ημερομηνία Τελευταίας Ενημέρωσης απο ΑΑΔΕ"),
      value: format(parseISO(caseData?.last_aade_check), "dd/MM/yyyy HH:mm"),
    },
  ].filter(Boolean);

  return (
    <Paper
      sx={{
        display: "flex",
        height: "100%",
        width: "100%",
        flexDirection: "column",
        padding: "1rem",
      }}
    >
      <h3>{t("Στοιχεία Υπόθεσης")}</h3>
      <Details rows={rows as DetailsRow[]} />
    </Paper>
  );
}
